import PropTypes from "prop-types";
import React from "react";

import AuthWizardProvider from "providers/AuthWizardProvider";

import WizardLayout from "./WizardLayout";

const Wizard = ({ variant, validation, progressBar }) => {
  return (
    <AuthWizardProvider>
      <WizardLayout
        variant={variant}
        validation={validation}
        progressBar={progressBar}
      />
    </AuthWizardProvider>
  );
};

Wizard.propTypes = {
  variant: PropTypes.oneOf(["pills"]),
  validation: PropTypes.bool,
  progressBar: PropTypes.bool,
};

export default Wizard;
